 
import { createContext, useContext } from 'react'

export type LayoutContextType = {
  isNavOpen: boolean,
  setNavOpen: React.Dispatch<React.SetStateAction<boolean>>,
}

export const LayoutContext = createContext<LayoutContextType>({
  isNavOpen: true,
  setNavOpen: () => { },
})

export const useLayoutContext = () => {
  const context = useContext(LayoutContext)

  if (context === undefined) {
    throw new Error(
      'useLayoutContext must be used within a LayoutContext.Provider',
    )
  }

  return context
}